import React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { brightColorCalendar } from "services/constants";

// error/helperText are additive (undefined by default, so behavior is
// unchanged for any other caller) -- routed through slotProps.textField
// since this project's installed @mui/x-date-pickers (v6) no longer reads
// the legacy renderInput prop this component used to (mis)use for its
// own TextField customization.
export const CustomDatePicker = ({
  value,
  onChange,
  minDate,
  maxDate,
  disabled,
  error,
  helperText,
  onError,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        <DatePicker
          size="small"
          value={value}
          onChange={(newValue) => {
            if (newValue) onChange(newValue);
          }}
          onError={onError}
          format="DD/MM/YYYY"
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          slotProps={{
            ...brightColorCalendar,
            textField: {
              ...brightColorCalendar.textField,
              fullWidth: true,
              width: "100%",
              // brightColorCalendar defaults to a calendar-only, read-only
              // text field (plus blocking the arrow keys that go with it) --
              // this picker should allow typing the date directly, so both
              // are overridden back to normal here.
              inputProps: {
                ...brightColorCalendar.textField.inputProps,
                readOnly: false,
                onKeyDown: undefined,
              },
              error,
              helperText,
            },
          }}
          sx={{ width: "100%" }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};
